import { useEffect, useState } from 'react';
import { Alert, Card, CardContent, Stack, Typography } from '@mui/material';

import { fetchMe } from '../api/client';
import { getRuntimeConfig } from '../runtime';

export function ReactAdminProbePage() {
  const runtime = getRuntimeConfig();
  const [result, setResult] = useState<string>('Checking session...');

  useEffect(() => {
    fetchMe()
      .then((me) => setResult(JSON.stringify(me, null, 2)))
      .catch((err) => setResult(err?.response?.data?.message ?? err.message ?? 'Unable to call /me'));
  }, []);

  return (
    <Stack spacing={3}>
      <Typography variant="h4" sx={{ fontWeight: 700 }}>
        API Probe
      </Typography>
      <Alert severity="info">Read-only session probe. This page only calls the existing Laravel /admin/app/me endpoint.</Alert>
      <Card>
        <CardContent>
          <Typography variant="subtitle2" color="text.secondary">
            Admin app URL
          </Typography>
          <Typography sx={{ mb: 2 }}>{runtime.adminAppUrl}</Typography>
          <Typography component="pre" sx={{ whiteSpace: 'pre-wrap', fontSize: 13, m: 0 }}>
            {result}
          </Typography>
        </CardContent>
      </Card>
    </Stack>
  );
}
